var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white tools"},[_c('div',{staticClass:"flex jus-con-cen font-16 map-font-theme mg-b-20 cursor-pointer",on:{"click":_vm.useRangingTool}},[_vm._v("测距")]),_c('div',{staticClass:"flex jus-con-cen font-16 map-font-theme mg-b-20 cursor-pointer"},[_c('a-icon',{attrs:{"type":"radar-chart"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }